import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserGear, faRightFromBracket } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useLocation } from 'react-router-dom'
import { useSendLogoutMutation } from '../features/auth/authApiSlice'
import useAuth from '../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'

const DashHeader = () => {
    const { isAdmin, username } = useAuth()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const [sendLogout, { isLoading, isSuccess, isError, error }] = useSendLogoutMutation()

    useEffect(() => {
        if (isSuccess) navigate('/')
    }, [isSuccess, navigate])

    const handleUsers = () => navigate('/dash/users')
    const handleLogout = () => sendLogout()

    const showUsersButton = (isAdmin)

    const errorClass = isError ? "errmsg text-danger mb-3 text-center" : "offscreen"

    return (
        <>
            <p className={errorClass}>{error?.data?.message}</p>

            <header className="bg border-bottom border-secondary border-opacity-25 shadow-sm">
                <div className="container">
                    <div className="row align-items-center min-vh-16 py-3 py-md-4">

                        {/* Left: Logo + Title */}
                        <div className="col-8 col-md-6 col-lg-5">
                            <div className="d-flex align-items-center">
                                <div className="me-3">
                                    <div className="bg-primary rounded-3 d-flex align-items-center justify-content-center shadow"
                                         style={{ width: '48px', height: '48px' }}>
                                        <i className="bi bi-house-door-fill text-white fs-3"></i>
                                    </div>
                                </div>
                                <div>
                                    <h1 className="h4 mb-0 text-white fw-bold">
                                        <button
                                            onClick={() => navigate('/dash')}
                                            className="text-white text-decoration-none bg-transparent border-0 p-0"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Nhà đẹp
                                        </button>
                                    </h1>
                                    <p className="text-light opacity-70 small mb-0">Quản trị hệ thống</p>
                                </div>
                            </div>
                        </div>

                        {/* Right: User Info + Action Buttons */}
                        <div className="col-4 col-md-6 col-lg-7 text-end">
                            <div className="d-flex align-items-center justify-content-end gap-3">


                                {/* Action Buttons */}
                                <div className="d-flex gap-2">

                                    {/* Users Button - Only for Admin */}
                                    {showUsersButton && (
                                        <button
                                            className={`btn ${pathname.includes('/users')
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                                } rounded-pill px-3 shadow-sm`}
                                            onClick={handleUsers}
                                            title="Quản lý người dùng"
                                        >
                                            <FontAwesomeIcon icon={faUserGear} />
                                            <span className="ms-2 d-none d-xl-inline">Người dùng</span>
                                        </button>
                                    )}

                                    {/* Logout Button */}
                                    <button
                                        className="btn btn-outline-danger rounded-pill px-3 shadow-sm"
                                        onClick={handleLogout}
                                        disabled={isLoading}
                                        title="Đăng xuất"
                                    >
                                        {isLoading ? (
                                            <PulseLoader color="#fff" size={8} />
                                        ) : (
                                            <>
                                                <FontAwesomeIcon icon={faRightFromBracket} />
                                                <span className="ms-2 d-none d-xl-inline">Thoát</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default DashHeader